<template>
  <div class="fillcontain">
    <search-item
      @showDialog="showAddMemberDialog"
      @searchList="getMemberList"
      @changePageAndLimit="handleChangePageAndLimit"
      @batchDelMember="onBatchDelMember"
    ></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="会员注册时间">
                <el-tag>{{ props.row.memberRegisterDate | filterTime }}</el-tag>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          v-if="idFlag"
          prop="userName"
          label="userName"
          align="center"
        ></el-table-column>
        <el-table-column
          width=""
          prop="telephoneNumber"
          label="手机号"
          align="left"
        ></el-table-column>
        <el-table-column
          width=""
          prop="name"
          label="姓名"
          align="left"
        ></el-table-column>
        <el-table-column
          width=""
          prop="classhour"
          label="剩余课时数"
          align="left"
        ></el-table-column>
        <el-table-column
          width=""
          prop="memberType"
          label="会员类型"
          align="left"
          :filters="fields.memberType.filter.list"
          :filter-method="filterMemberType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterMemberType(scope.row)"
              :type="scope.row.memberType === 0 ? 'warning' : 'success'"
              disable-transitions
              >{{ scope.row.memberType }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          width=""
          prop="memberStatus"
          label="会员状态"
          align="left"
          :filters="fields.memberStatus.filter.list"
          :filter-method="filterMemberStatus"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterMemberStatus(scope.row)"
              :type="scope.row.memberStatus === 0 ? 'danger' : 'success'"
              disable-transitions
              >{{ scope.row.memberStatus }}</el-tag
            >
          </template>
        </el-table-column>
         <el-table-column
          width=""
          prop="memberRegisterDate"
          label="注册时间"
          align="center"
        >
          <template slot-scope="scope">
            {{scope.row.memberRegisterDate.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column
          width=""
          prop="memberNote"
          label="备注"
          align="center"
        ></el-table-column>
        <el-table-column width="" prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              v-show="ROLE == 1"
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditMember(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteMember(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          width=""
          prop="operation"
          align="left"
          label="操作"
          fit
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="onGotoClassHourRecordPage(scope.row, scope.$index)"
              >课时账单</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          width=""
          prop="operation"
          align="left"
          label="操作"
          fit
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="onGotoMemberCoursePackagePage(scope.row, scope.$index)"
              >课包管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addMemberDialog.show"
        :isShow="addMemberDialog.show"
        :dialogRow="addMemberDialog.dialogRow"
        @getMemberList="getMemberList"
        @closeDialog="hideAddFundDialog"
        @changePageAndLimit="changePageAndLimit"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addFundDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime } from "../../utils/date.js";
import { getMemberInfo, deleteMember, batchDeleteMember } from "@/api/member";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      ROLE: 0,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,

      format_member_type_list: {
        0: "临时会员",
        1: "正式会员",
      },
      format_member_status_list: {
        0: "待审核",
        1: "审核通过",
      },
      addMemberDialog: {
        show: false,
        dialogRow: {},
      },
      memberData: {
        page: 1,
        limit: 20,
        // name: ""
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {
        memberType: {
          filter: {
            list: [
              {
                text: "临时会员",
                value: 0,
              },
              {
                text: "正式会员",
                value: 1,
              },
            ],
          },
        },
        memberStatus: {
          filter: {
            list: [
              {
                text: "待审核",
                value: 0,
              },
              {
                text: "审核通过",
                value: 1,
              },
            ],
          },
        },
      },
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["search", "memberSearch", "roles"]),
  },
  created() {
    this.ROLE = getToken("ROLE");
    // console.log(this.ROLE);
  },
  mounted() {
    // console.log("管理员权限:" + this.roles);
    this.getMemberList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleChangePageAndLimit() {
      this.memberData.page = 1;
      this.memberData.limit = 20;
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    onGotoClassHourRecordPage(row) {
      const para = { username: row.userName, name: row.name };
      this.$store.commit("SET_USER", para);
      this.$router.push({ path: "/memberManage/classhourSpendList" });
    },
    onGotoMemberCoursePackagePage(row) {
      const para = {
        username: row.userName,
        name: row.name,
        telephone: row.telephoneNumber,
      };
      this.$store.commit("SET_USER", para);
      this.$router.push({ path: "/memberManage/memberCoursePackage" });
    },
    //获取会员列表数据
    getMemberList() {
      const para = Object.assign({}, this.memberData, this.memberSearch);
      // console.log(para);
      getMemberInfo(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.memberData;
      });
    },
    // 显示资金弹框
    showAddMemberDialog(val) {
      this.$store.commit("SET_MEMBER_DIALOG_TITLE", val);
      this.addMemberDialog.show = true;
    },
    hideAddFundDialog() {
      this.addMemberDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.memberData.page = val;
      this.getMemberList();
    },
    changePageAndLimit() {
      this.memberData.page = 1;
      this.memberData.limit = 20;
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.memberData.limit = val;
      this.getMemberList();
    },
    /**
     * 格式化状态
     */
    formatterMemberType(item) {
      const type = parseInt(item.memberType);
      return this.format_member_type_list[type];
    },
    formatterMemberStatus(item) {
      const type = parseInt(item.memberStatus);
      return this.format_member_status_list[type];
    },
    filterMemberType(value, item) {
      const type = parseInt(item.memberType);
      return (
        this.format_member_type_list[value] ==
        this.format_member_type_list[type]
      );
    },
    filterMemberStatus(value, item) {
      const type = parseInt(item.memberStatus);
      return (
        this.format_member_status_list[value] ==
        this.format_member_status_list[type]
      );
    },
    // 编辑操作方法
    onEditMember(row) {
      this.addMemberDialog.dialogRow = { ...row };
      this.showAddMemberDialog();
    },
    // 删除数据
    onDeleteMember(row) {
      this.$confirm("是否移入回收站?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { username: row.userName };
          deleteMember(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.name + ")会员操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getMemberList();
          });
        })
        .catch(() => {});
    },
    onBatchDelMember() {
      // console.log("onbatchdelmember");
      this.$confirm("确认批量删除记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelection
            .map((item) => item.telephoneNumber)
            .toString();
          const para = { telephoneNumbers: ids };
          batchDeleteMember(para).then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "批量删除成功",
                type: "success",
              });
              this.getMemberList();
            }
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_MEMBER_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


